import React, { useEffect, useState } from 'react'
import { deleteRecord, details, doDownloadFile, setDetails, setPerPageSize } from './utils/slice';
import { useAppDispatch, useAppSelector } from '../../../store/app';
import { useNavigate, useParams } from 'react-router-dom';
import { checkPrivileges, downloadFile } from '../../../config/Global';
import { CONSTANT } from '../../../config/Constant';
import ToolBar from '../../../components/ToolBar';
import { CitizenBreadcrumb } from '../../../config/BreadcrumbConfig';
import CreateButton from '../../../components/ToolBar/Buttons/CreateButton';
import RecordPerPage from '../../../components/ToolBar/Dropdown/RecordPerPage';
import ContentBox from '../../../components/ContentBox/ContentBox';
import Listing from './Components/Listing/Listing';
import AddComponent from './Components/Form/AddComponent';
import EditComponent from './Components/Form/EditComponent';
import ViewDrawer from './Components/ViewDrawer';
import DeleteModal from '../../../components/Modals/DeleteModal';
import { ModuleInfoProps } from '../../../config/InterfacesAndTypes';
import { Button, Popover } from 'antd';
import MeetingComponent from './MeetingComponent/MeetingComponent';
import { PlusOutlined, DownloadOutlined } from "@ant-design/icons";
import { useTranslation } from 'react-i18next';

const CitizenManagement: React.FC<ModuleInfoProps> = (moduleInfo) => {
	const { t } = useTranslation();
	const dispatch = useAppDispatch();
	const navigate = useNavigate();
	const { action, id } = useParams();
	const [visibleDrawer, setVisibleDrawer] = useState<string | null>(null);
	const userDetail = useAppSelector((state) => state.auth.userDetail);
	const { perPage } = useAppSelector((state) => state.citizen);
	const [deleteValue, setDeleteValue] = useState<any>();
	const [exportOpen, setExportOpen] = useState(false);

	const getDetails = (id: any, type: string) => {
		dispatch(details(id))
			.then(() => {
				setVisibleDrawer(type)
			})
			.catch(() => {
				navigateToIndex()
			})
	}
	const navigateToIndex = () => {
		setDetails(null);
		setVisibleDrawer(null);
		navigate(`${moduleInfo.indexRoute}`);
	};


	useEffect(() => {
		if (action) {
			if (action === CONSTANT.DRAWER_TYPE.ADD && userDetail && !checkPrivileges(userDetail, `${moduleInfo.permissionPrefix}_CREATE`)) {
				navigateToIndex()
				return
			}
			if (action === CONSTANT.DRAWER_TYPE.EDIT && userDetail && !checkPrivileges(userDetail, `${moduleInfo.permissionPrefix}_UPDATE`)) {
				navigateToIndex()
				return
			}
			if (action === CONSTANT.DRAWER_TYPE.VIEW && userDetail && !checkPrivileges(userDetail, `${moduleInfo.permissionPrefix}_DETAILS`)) {
				navigateToIndex()
				return
			}

			if (!id && action) {
				setVisibleDrawer(action);
			} else if (id && action) {
				getDetails(id, action);
			} else {
				navigateToIndex();
			}
		}
	}, [userDetail, action, id]);
	const meetingBtn = () => {
		navigate(`${moduleInfo.indexRoute}/${CONSTANT.DRAWER_TYPE.CITIZENSWITHMEETING}`)
	};

	const handleOpenChange = (newOpen: boolean) => {
		setExportOpen(newOpen);
	};

	const ExportFile = (value: any) => {
		if (value === "Excel") {
			dispatch(doDownloadFile(2)).then((res: any) => {
				const base64 = res?.list
				const fileType = "text/csv"
				downloadFile(base64, fileType, "Visiter Register")
				setExportOpen(false);
			})
		}
	}
	const content = (
		<div className='exportReportFile'>
			<div onClick={() => ExportFile("Excel")} style={{ cursor: "pointer" }}>{t("MLAGRANTMANAGEMENT.EXCEL")}</div>
		</div>
	);

	return (
		<>
			<ToolBar breadcrumbs={CitizenBreadcrumb(t)}>
				{
					checkPrivileges(userDetail, `${moduleInfo.permissionPrefix}_EXPORT`) &&
					 <Popover
						content={content}
						trigger="click"
						open={exportOpen}
						onOpenChange={handleOpenChange}
						placement='bottom'
					>
						<Button type="primary">{t("MLAGRANTMANAGEMENT.EXPORT_BUTTON")} <DownloadOutlined /></Button>
					</Popover>
				}

				{checkPrivileges(userDetail, `${moduleInfo.permissionPrefix}_MEETING_CREATE`)
					&&
					<Button
						className="primaryBtn"
						onClick={() => meetingBtn()}>
						{t("CITIZENMANAGEMENT.MEETING_WITH_CITIZENS_BUTTON")} <PlusOutlined />
					</Button>
				}
				<CreateButton
					action={() =>
						navigate(`${moduleInfo.indexRoute}/${CONSTANT.DRAWER_TYPE.ADD}`)
					}
					permissionKey={`${moduleInfo.permissionPrefix}_CREATE`}
				/>

				<RecordPerPage
					perPage={perPage}
					onChange={(perPageSize: number) => {
						dispatch(setPerPageSize(perPageSize));
					}}
				/>
			</ToolBar>
			<ContentBox>
				<Listing
					moduleInfo={moduleInfo}
					handleViewClick={(data: any) => {
						navigate(
							`${moduleInfo.indexRoute}/${CONSTANT.DRAWER_TYPE.VIEW}/${data.id}`
						);
					}}
					handleEditClick={(data: any) => {
						navigate(
							`${moduleInfo.indexRoute}/${CONSTANT.DRAWER_TYPE.EDIT}/${data.id}`
						);
					}}
					handleDeleteClick={setDeleteValue}
				/>
				<MeetingComponent
					titleName={moduleInfo.title}
					open={visibleDrawer === CONSTANT.DRAWER_TYPE.CITIZENSWITHMEETING}
					close={navigateToIndex}
					moduleInfo={moduleInfo}
				/>
				<AddComponent
					titleName={`${t("CITIZENMANAGEMENT.Visitor")}`}
					open={visibleDrawer === CONSTANT.DRAWER_TYPE.ADD}
					close={navigateToIndex}
				/>
				<EditComponent
					titleName={t("CITIZENMANAGEMENT.Visitor")}
					open={visibleDrawer === CONSTANT.DRAWER_TYPE.EDIT}
					close={navigateToIndex}
				/>
				<ViewDrawer
					titleName={t("CITIZENMANAGEMENT.Visitor")}
					open={visibleDrawer === CONSTANT.DRAWER_TYPE.VIEW}
					close={navigateToIndex}
				/>
				<DeleteModal
					title={t("CITIZENMANAGEMENT.Visitor")}
					deleteValues={deleteValue}
					callApi={deleteRecord}
					close={() => setDeleteValue(null)}
					keyName="first_name"
				/>
			</ContentBox>
		</>
	)
}

export default CitizenManagement